<template>
  <v-card>
    <v-card-text>
      <v-form v-model="valid" ref="form" id="tambahkan-lahan" lazy-validation>
        <h2 style="margin: 0% auto;"><b>Lahan Baru</b></h2>
        <h5>Lahan > Tambahkan Lahan</h5>
        <v-layout row wrap>

          <v-flex lg12 sm12>
            <v-select
              prepend-icon="fas fa-mountain"
              v-model="jenisLahan"
              :items="tipeLahan"
              label="Pilih Jenis Lahan"
            ></v-select>
            <small v-if="!isJenisLahan" class="alert">Pilih Jenis Lahan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="person" label="Nama Petani" name="namaPetani" v-model="namaPetani">
            </v-text-field>
            <small v-if="!isNamaPetani" class="alert">Nama Petani Minimal 3 Karakter</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="phone" label="Kontak" name="kontakPetani" v-model="kontakPetani" type="number">
            </v-text-field>
            <small v-if="!isKontakPetani" class="alert">Kontak Petani Minimal 10 digit</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-apple-alt" label="Komoditas Lahan Pertanian" name="komoditasLahanPetani" v-model="komoditasLahanPetani">
            </v-text-field>
            <small v-if="!isKomoditasLahan" class="alert">Masukan Komoditas Lahan Pertanian</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Jalan" name="alamatJalan" v-model="alamatJalan">
            </v-text-field>
            <small v-if="!isAlamatJalan" class="alert">Masukan Jalan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Desa" name="alamatDesa" v-model="alamatDesa">
            </v-text-field>
            <small v-if="!isAlamatDesa" class="alert">Masukan Desa</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kecamatan" name="alamatKecamatan" v-model="alamatKecamatan">
            </v-text-field>
            <small v-if="!isAlamatKecamatan" class="alert">Masukan Kecamatan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marked-alt" label="Kabupaten" name="alamatKabupaten" v-model="alamatKabupaten">
            </v-text-field>
            <small v-if="!isAlamatKabupaten" class="alert">Masukan Kabupaten</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-select
              prepend-icon="fas fa-map-marked-alt"
              v-model="alamatProvinsi"
              :items="tipeProvinsi"
              label="Pilih Provinsi"
            ></v-select>
            <small v-if="!isAlamatProvinsi" class="alert">Pilih Provinsi</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field label="Upload Dokumen Pertanahan" @click='pickFile' v-model='imageName' prepend-icon='upload_file'></v-text-field>
            <input
              type="file"
              style="display: none"
              ref="image"
              accept="image/*"
              @change="onFilePicked"
            >
            <small v-if="!isUploadDokumenPertanahan" class="alert">Upload Dokumen Pertanahan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-map-marker-alt" label="Koordinasi Spasial" name="koordinasiSpasial" v-model="koordinasiSpasial">
            </v-text-field>
            <small v-if="!isKoordinasiSpasial" class="alert">Masukan Koordinasi Spasial</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-money" label="Modal Per Musim Tanam" name="modalMusimTanam" v-model="modalMusimTanam" prefix="Rp. " suffix="/Musim Tanam">
            </v-text-field>
            <small v-if="!isModalMusimTanam" class="alert">Masukan Modal Per Musim Tanam</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-seedling" label="Sumber Benih" name="sumberBenih" v-model="sumberBenih">
            </v-text-field>
            <small v-if="!isSumberBenih" class="alert">Masukan Sumber Benih</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-seedling" label="Saprotan yang Digunakan" name="sumberSaprotan" v-model="sumberSaprotan">
            </v-text-field>
            <small v-if="!isSumberSaprotan" class="alert">Masukan Sumber Saprotan</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-seedling" label="Jenis Pupuk Per Musim" name="jenisPupukPerMusim" v-model="jenisPupukPerMusim">
            </v-text-field>
            <small v-if="!isJenisPupukPerMusim" class="alert">Masukan Jenis Pupuk Per Musim</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-leaf" label="Jenis Tanaman yang Digunakan" name="jenisTanaman" v-model="jenisTanaman">
            </v-text-field>
            <small v-if="!isJenisTanaman" class="alert">Masukan Jenis Tanaman</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="fas fa-seedling" label="Distribusi Bibit Ke Lapangan" name="distribusiBibit" v-model="distribusiBibit">
            </v-text-field>
            <small v-if="!isDistribusiBibit" class="alert">Masukan Distribus Bibit</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-select
              prepend-icon="fas fa-calendar-alt"
              v-model="waktuTanamBulan"
              :items="tipeWaktuTanamBulan"
              label="Perkiraan Waktu Tanam (Bulan)"
            ></v-select>
            <v-select
              prepend-icon="fas fa-calendar-alt"
              v-model="waktuTanamTahun"
              :items="tipeWaktuTanamTahun"
              label="Perkiraan Waktu Tanam (Tahun)"
            ></v-select>
            <small v-if="!isWaktuTanamBulan && !isWaktuTanamTahun" class="alert">Pilih Bulan dan Tahun Tanam</small>
          </v-flex>

          <v-flex sm12 lg12>
            <v-menu
              ref="estimasiTanggalPemeliharaanLanjut"
              lazy
              class="pr-2"
              :close-on-content-click="false"
              v-model="estimasiTanggalPemeliharaanLanjutMenu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-bottom="-22"
              min-width="290px"
              :return-value.sync="estimasiTanggalPemeliharaanLanjut"
            >
              <v-text-field
                slot="activator"
                label="Perkiraan Pemeliharaan Lanjut"
                v-model="estimasiTanggalPemeliharaanLanjut"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="estimasiTanggalPemeliharaanLanjut" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="estimasiTanggalPemeliharaanLanjutMenu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.estimasiTanggalPemeliharaanLanjut.save(estimasiTanggalPemeliharaanLanjut)">OK</v-btn>
              </v-date-picker>
            </v-menu>
            <small v-if="!isEstimasiTanggalPemeliharaanLanjut" class="alert">Pilih Perkiraan Tanggal Pemeliharaan Lanjut</small>
          </v-flex>

          <v-flex lg12 sm12>
            <v-text-field prepend-icon="event" label="Jenis Kegiatan Pemeliharaan" name="jenisKegiatanPemeliharaan" v-model="jenisKegiatanPemeliharaan">
            </v-text-field>
            <small v-if="!isJenisKegiatanPemeliharaan" class="alert">Masukan Jenis Kegiatan Pemeliharaan</small>
          </v-flex>

          <v-flex sm12 lg12>
            <v-menu
              ref="estimasiTanggalPanen"
              lazy
              class="pr-2"
              :close-on-content-click="false"
              v-model="estimasiTanggalPanenMenu"
              transition="scale-transition"
              offset-y
              full-width
              :nudge-bottom="-22"
              min-width="290px"
              :return-value.sync="estimasiTanggalPanen"
            >
              <v-text-field
                slot="activator"
                label="Perkiraan Waktu Panen"
                v-model="estimasiTanggalPanen"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="estimasiTanggalPanen" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="estimasiTanggalPanenMenu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.estimasiTanggalPanen.save(estimasiTanggalPanen)">OK</v-btn>
              </v-date-picker>
            </v-menu>
            <small v-if="!isEstimasiTanggalPanen" class="alert">Pilih Perkiraan Tanggal Panen</small>
          </v-flex>
        </v-layout>

        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn color="error" @click="back">Batal</v-btn>
          <v-btn color="primary" form="tambahkan-lahan" @click="getGapoktanLahan" :disabled="!isComplete">Tambahkan Lahan</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>

      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'
import { format } from 'path';

export default {
  components: {
  },
  data: () => ({
    valid: true,
    date: null,
    modal: false ,

    jenisLahan: null,
    tipeLahan: [
      'Pertanian',
      'Kehutanan',
      'Peternakan',
      'Perikanan',
    ],  
    namaPetani: null,
    kontakPetani: null,
    komoditasLahanPetani: null,
    alamatJalan: null,
    alamatDesa: null,
    alamatKecamatan: null,
    alamatKabupaten: null,
    alamatProvinsi: null,
    tipeProvinsi: [
      'Aceh',
      'Bali',
      'Banten',
      'Bengkulu',
      'Daerah Istimewa Yogyakarta',
      'Gorontalo',
      'Jakarta',
      'Jambi',
      'Jawa Barat',
      'Jawa Tengah',
      'Jawa Timur',
      'Kalimantan Barat',
      'Kalimantan Selatan',
      'Kalimantan Tengah',
      'Kalimantan Timur',
      'Kalimantan Utara',
      'Kepulauan Bangka Belitung',
      'Kepulauan Riau',
      'Lampung',
      'Maluku',
      'Maluku Utara',
      'Nusa Tenggara Barat',
      'Nusa Tenggara Timur',
      'Papua',
      'Papua Barat',
      'Riau',
      'Sulawesi Barat',
      'Sulawesi Selatan',
      'Sulawesi Tengah',
      'Sulawesi Tenggara',
      'Sulawesi Utara',
      'Sumatra Barat',
      'Sumatra Selatan',
      'Sumatra Utara'
    ],  
    koordinasiSpasial: null,
    modalMusimTanam: null,
    sumberBenih: null,
    sumberSaprotan: null,
    jenisPupukPerMusim: null,
    jenisTanaman: null,
    distribusiBibit: null,
    waktuTanamBulan: null,
    tipeWaktuTanamBulan: [
      'Januari',
      'Februrari',
      'Maret',
      'April',
      'Mei',
      'Juni',
      'Juli',
      'Agustus',
      'September',
      'Oktober',
      'November',
      'Desember'
    ],  
    waktuTanamTahun: null,
    tipeWaktuTanamTahun: [
      '2019','2020','2021','2022','2023',
      '2024','2025','2026','2027','2028',
      '2029','2030','2031','2032','2033',
      '2034','2035','2036','2037','2038',
      '2039','2040','2041','2042','2043',
      '2044','2045','2046','2047','2048',
      '2049','2050','2051','2052','2053',
    ],  
    estimasiTanggalPemeliharaanLanjutMenu: false,
    estimasiTanggalPemeliharaanLanjut: null,
    jenisKegiatanPemeliharaan: null,
    estimasiTanggalPanenMenu: false,
    estimasiTanggalPanen: null,

    imageName: null,
		imageUrl: null,
		promotionImage: null,
    currentDateGapoktan: null,

    // Form Check
    reg: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
  }),

  computed: {
    tipeDocs() {
      return [
        'Dokumen Usaha Dagang Perantara',
        this.kodePenjualan
      ]
    },

    // Form Check
    isComplete () {
      return (this.jenisLahan) && (this.namaPetani && this.namaPetani.length >= 3) && (this.kontakPetani && this.kontakPetani.length >= 8) && (this.komoditasLahanPetani) && (this.alamatJalan) && (this.alamatDesa) && (this.alamatKecamatan) && (this.alamatKabupaten) && (this.alamatProvinsi) && (this.imageName) && (this.koordinasiSpasial) && (this.modalMusimTanam && this.modalMusimTanam >= 0) && (this.sumberBenih) && (this.sumberSaprotan) && (this.jenisPupukPerMusim) && (this.jenisTanaman) && (this.distribusiBibit) && (this.waktuTanamBulan) && (this.waktuTanamTahun) && (this.jenisKegiatanPemeliharaan) && (this.estimasiTanggalPanen);
    },
    
    isJenisLahan () {
      return (this.jenisLahan);
    },

    isNamaPetani(){
      return (this.namaPetani && this.namaPetani.length >= 3)
    },

    isKontakPetani(){
      return (this.kontakPetani && this.kontakPetani >= 0 && this.kontakPetani.length >= 8)
    },

    isKomoditasLahan(){
      return (this.komoditasLahanPetani)
    },

    isAlamatJalan(){
      return (this.alamatJalan)
    },

    isAlamatDesa(){
      return (this.alamatDesa)
    },

    isAlamatKecamatan(){
      return (this.alamatKecamatan)
    },

    isAlamatKabupaten(){
      return (this.alamatKabupaten)
    },

    isAlamatProvinsi(){
      return (this.alamatProvinsi)
    },

    isUploadDokumenPertanahan(){
      return (this.imageName)
    },

    isKoordinasiSpasial(){
      return (this.koordinasiSpasial)
    },

    isModalMusimTanam(){
      return (this.modalMusimTanam && this.modalMusimTanam >= 0)
    },

    isSumberBenih(){
      return (this.sumberBenih)
    },

    isSumberSaprotan(){
      return (this.sumberSaprotan)
    },

    isJenisPupukPerMusim(){
      return (this.jenisPupukPerMusim)
    },

    isJenisTanaman(){
      return (this.jenisTanaman)
    },

    isDistribusiBibit(){
      return (this.distribusiBibit)
    },

    isWaktuTanamBulan(){
      return (this.waktuTanamBulan)
    },

    isWaktuTanamTahun(){
      return (this.waktuTanamTahun)
    },

    isEstimasiTanggalPemeliharaanLanjut(){
      return (this.estimasiTanggalPemeliharaanLanjut)
    },

    isJenisKegiatanPemeliharaan(){
      return (this.jenisKegiatanPemeliharaan)
    },

    isEstimasiTanggalPanen(){
      return (this.estimasiTanggalPanen)
    },

},

  methods: {
    pickFile () {
      this.$refs.image.click ()
    },
		
		onFilePicked (e) {
			const files = e.target.files
			if(files[0] !== undefined) {
				this.imageName = files[0].name
				if(this.imageName.lastIndexOf('.') <= 0) {
					return
				}
				const fr = new FileReader ()
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
					this.imageUrl = fr.result
					this.promotionImage = files[0] // this is an image file that can be sent to server...
				})
			} else {
				this.imageName = ''
				this.promotionImage = ''
				this.imageUrl = ''
			}
		},

    closeDialog () {
      this.$parent.isActive = false;
    },

    back(){
      window.getApp.$emit('APP_GAPOKTAN');
      // return '/pemerintah';
    },

    saveTemplate(){
      // window.getApp.$emit('APP_SIMPAN_TEMPLATE');
    },

    getGapoktanLahan (){
      // Data General
      localStorage.gapoktanLahanID = 'GAL-19040010'
      localStorage.gapoktanLahanJenis = this.jenisLahan,
      localStorage.gapoktanLahanNamaPetani = this.namaPetani,
      localStorage.gapoktanLahanKontakPetani = this.kontakPetani,
      localStorage.gapoktanLahanKomoditasLahanPetani = this.komoditasLahanPetani,
      localStorage.gapoktanLahanAlamatJalan = this.alamatJalan,
      localStorage.gapoktanLahanAlamatDesa = this.alamatDesa,
      localStorage.gapoktanLahanAlamatKecamatan = this.alamatKecamatan,
      localStorage.gapoktanLahanAlamatKabupaten = this.alamatKabupaten,
      localStorage.gapoktanLahanAlamatProvinsi = this.alamatProvinsi,
      localStorage.gapoktanLahanKoordinasiSpasial = this.koordinasiSpasial,
      localStorage.gapoktanLahanModalMusimTanam = this.modalMusimTanam,
      localStorage.gapoktanLahanSumberBenih = this.sumberBenih,
      localStorage.gapoktanLahanSumberSaprotan = this.sumberSaprotan,
      localStorage.gapoktanLahanJenisPupukPerMusim = this.jenisPupukPerMusim,
      localStorage.gapoktanLahanJenisTanaman = this.jenisTanaman,
      localStorage.gapoktanLahanDistribusiBibit = this.distribusiBibit,
      localStorage.gapoktanLahanWaktuTanamBulan = this.waktuTanamBulan,
      localStorage.gapoktanLahanWaktuTanamTahun = this.waktuTanamTahun,
      localStorage.gapoktanLahanEstimasiTanggalPemeliharaanLanjut = moment(this.estimasiTanggalPemeliharaanLanjut).format('DD-MM-YYYY');
      localStorage.gapoktanLahanJenisKegiatanPemeliharaan = this.jenisKegiatanPemeliharaan,
      localStorage.gapoktanLahanEstimasiTanggalPanen = moment(this.estimasiTanggalPanen).format('DD-MM-YYYY');

      // Sistem
      localStorage.gapoktanLahanDibuat = moment().format('DD-MM-YYYY');

      window.getApp.$emit('APP_GAPOKTAN_SUCCESS');

    }
  }
};
</script>

<style lang="stylus" scoped>
  .quill
    height : 360px
</style>
